import { Box } from '@wix/design-system';
import React from 'react';
export const GroupSuffix = _ref => {
  let {
    ruleGroupContent,
    isOpen,
    datahook
  } = _ref;
  const {
    badge,
    expandNode,
    collapsedNode
  } = ruleGroupContent;
  const nodeToDisplay = isOpen ? expandNode : collapsedNode;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: datahook,
    direction: "horizontal"
  }, badge, nodeToDisplay);
};
//# sourceMappingURL=group-suffix.js.map